<section class="service-detail-section">
    <div>
        <div class="service-header">
            <img [src]="'./assets/images/services/protection-de-bien-mobilier-et-immobilier.png'" [alt]="'protection-de-bien-mobilier-et-immobilier'" class="service-image">
            <div class="social-icons">
                <a href="#" class="social-link">
                    <img src="assets/images/icons/facebook.png" alt="Facebook">
                </a>
                <a href="#" class="social-link">
                    <img src="assets/images/icons/instagram.png" alt="Instagram">
                </a>
                <a href="#" class="social-link">
                    <img src="assets/images/icons/linkedin.png" alt="LinkedIn">
                </a>
            </div>
        </div>

        <div class="service-container">
            <div class="service-container-header">
                <div class="left-side">
                    <h1>Protection de bien<br> mobilier et immobilier</h1>
                </div>
                <div class="right-side">
                    <a [routerLink]="['/routePath']" routerLinkActive="router-link-active" class="service-link">
                        <img src="assets/images/icons/shield_check.png" alt="Shield icon" class="link-icon">
                        <span class="link-text">Demander notre service</span>
                        <img src="assets/images/icons/link_arrow.png" alt="Arrow" class="arrow-icon">
                    </a>
                </div>
            </div>
            <div class="service-content">
                <h2>Surveillance et protection de biens mobiliers<br> et immobiliers...</h2>
                <p>Centres commerciaux, complexes immobiliers, les administrations, les établissements financiers, bureaux, sites industriels, entrepôts, parkings, chantiers, centres aquatiques, foires commerciales, parcs d’attractions, VIP, … </p>
                <p class="mt-5 mb-2">Le gardiennage statique pour :</p>
                <ul class="mb-2">
                    <li>La prévention vols, intrusion </li>
                    <li>Des actes violents</li>
                    <li>Toutes autres formes de violence…</li>
                </ul>
                <p class="">Nos agents spécialisés sont formés à gérer des situations telles que des débuts d’incendies, des inondations, des problèmes plus techniques,…</p>
                <p class="mt-4 mb-2">Des procédures au cas par cas sont élaborées afin d’optimiser nos prestations et interventions :</p>
                <ul class="mb-2">
                    <li>Ouverture de barrières et de portes </li>
                    <li>Accompagnement et orientation des visiteurs</li>
                    <li>Gestion des clés, des badges et autres …</li>
                    <li>Gestion des systèmes d’alarme et incendie (Bemac,…)</li>
                    <li>Accréditation (entrée-sortie)</li>
                    <li>Rondes de prévention intérieures et extérieures</li>
                    <li>Réception et orientation des marchandises</li>
                    <li>Contrôles du personnel</li>
                    <li>Etc...</li>
                </ul>
            </div>
        </div>
    </div>
</section>